import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
export function servicesStackedScroll(element, matchMediaString) {
    const selector = document.querySelector(element);
    if (!selector) return;

    const animateClass = 'gsap-animate';
    const mediaQuery = window.matchMedia(matchMediaString ? matchMediaString : '(min-width: 768px)');

    // Define a function that will handle the scroll animations
    function handleScrollAnimations() {
        const items = Array.from(selector.children);
        const animatedItems = items.splice(0, selector.children.length - 1);

        animatedItems.forEach((item, i) => {

            item.classList.add(animateClass);
            const timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: item,
                    start: 'top top',
                    end: '120% top',
                    scrub: 0.25,
                    markers: false,
                },
            });

            timeline.fromTo(item, {
                boxShadow: 'inset 0px 0px 0px 100vh rgba(0,0,0,0.0)',
                filter: 'blur(0px)',
            }, {
                boxShadow: 'inset 0px 0px 0px 100vh rgba(0,0,0,0.25)',
                filter: 'blur(3px)',
            }).fromTo(item, {
                ease: 'power4',
            }, {
                y: '-10vh',
                ease: 'power4',
            }, '<').to(item.querySelector('.quicklinks__container'), {
                scale: '0.975',
                ease: 'power4',
            }, '<');
        });
    }

    // Define a function to kill all ScrollTriggers
    function destroyScrollAnimations() {
        // Kill all ScrollTriggers created by GSAP
        ScrollTrigger.getAll().forEach((trigger) => {
            if (!trigger.trigger.className.includes('pane--cta')) {
                trigger.kill();
            }
        });
    }

    // Check the media query and run or destroy the animations
    function checkMediaQuery(e) {
        destroyScrollAnimations();

        if (e.matches) {
            handleScrollAnimations();
        } else {
            destroyScrollAnimations();
        }
    }

    // Initial check and setup
    checkMediaQuery(mediaQuery);

    // Add a listener to respond to changes in the media query
    mediaQuery.addListener(checkMediaQuery);
}
